<template>
  <div class="py-5 container-fluid">
    <div class="row mt-4 justify-content-center">
      <div class="col-12">
        <div class="mx-auto col-xl-8 col-lg-9 col-md-10 text-start mt-3 mb-0">
          <button
            class="btn btn-outline-secondary btn-sm px-3 ms-2 mt-1"
            @click="$router.push({ name: 'LineVisits', params: { lineId: lineId }});"
          >
            <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
            Go back to visits
          </button>
        </div>
        <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header text-center">
              <h3 class="font-weight-bolder text-success text-gradient">
                {{ $t("Health Check") }}
              </h3>
              <h5 v-if="line.name" class="mb-0">
                for Line <i>{{ line.name }}</i>
              </h5>
            </div>
          </div>
        <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur">
          <div
            class="card-body mb-0 pb-3"
            style="padding-top: 0.5rem"
          >
            <div class="row">
              <div
                class="col mt-5"
                style="margin-left: 3%"
              >
                <div
                  class="row"
                  style="display: flex; align-items: center"
                >
                  <div class="col-xl-6 col-lg-7 col-md-8 col-sm-9">
                    <h6>Gun to gun distance OK?</h6>
                  </div>
                  <div class="col">
                    <input
                      id="gun_to_gun_distance_check"
                      v-model="gun_to_gun_distance_check_form"
                      :disabled="visit.finalized_at_stage !== 'not_finalized'"
                      type="checkbox"
                      style="display: none"
                    />
                    <label
                      for="gun_to_gun_distance_check"
                      style="
                        display: inline-block;
                        width: 2rem;
                        height: 2rem;
                        border-radius: 50%;
                        border: 2px solid #ccc;
                        position: relative;
                        cursor: pointer;
                      "
                    >
                      <span
                        v-if="gun_to_gun_distance_check_form"
                        style="
                          display: block;
                          width: 1.5rem;
                          height: 1.5rem;
                          border-radius: 50%;
                          background: #070;
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                        "
                      ></span>
                    </label>
                  </div>
                </div>
                <div
                  class="row mt-4"
                  style="display: flex; align-items: center"
                >
                  <div class="col-xl-6 col-lg-7 col-md-8 col-sm-10">
                    <h6 style="margin-right: 10px">Venturi Nozzles OK?</h6>
                  </div>
                  <div class="col-4 mt-2">
                    <input
                      id="nozzles_check"
                      v-model="nozzles_check_form"
                      :disabled="visit.finalized_at_stage !== 'not_finalized'"
                      type="checkbox"
                      style="display: none"
                    />
                    <label
                      for="nozzles_check"
                      style="
                        display: inline-block;
                        width: 2rem;
                        height: 2rem;
                        border-radius: 50%;
                        border: 2px solid #ccc;
                        position: relative;
                        cursor: pointer;
                      "
                    >
                      <span
                        v-if="nozzles_check_form"
                        style="
                          display: block;
                          width: 1.5rem;
                          height: 1.5rem;
                          border-radius: 50%;
                          background: #070;
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                        "
                      ></span>
                    </label>
                  </div>
                </div>
                <div class="row mt-4">
                  <h6>Venturi Nozzles Last change</h6>
                  &nbsp;&nbsp;
                  <input
                    v-model="nozzle_last_changed_date_form"
                    class="form-control mt-2"
                    :disabled="visit.finalized_at_stage !== 'not_finalized'"
                    type="date"
                    style="width: 50%"
                  />
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center text-center">
                  <h6>Notes</h6>
                  <textarea
                    v-model="notes_form"
                    class="form-control my-2"
                    placeholder="Enter notes here"
                    :disabled="visit.finalized_at_stage !== 'not_finalized'"
                    type="text"
                    style="height: 240px; width: 80%; min-height: 40px"
                  ></textarea>
                </div>
              </div>
              <div
                v-if="formUpdated"
                class="col-12 text-center mt-5"
              >
                <button
                  :class="`btn ${formUpdated ? 'btn-success' : 'btn-secondary'}`"
                  :disabled="!formUpdated"
                  style="width: 90%"
                  @click="saveHealthCheck()"
                >
                  SAVE
                </button>
              </div>
              <div
                v-if="!formUpdated"
                class="col-12 text-end mt-5"
              >
                <soft-button
                  type="button"
                  color="success"
                  variant="gradient"
                  class="mb-0 ms-auto js-btn-next w-45"
                  style="max-width: 300px;"
                  title="Continue to guns equalization"
                  @click="$router.push({ name: 'GunsEqualization', params: { lineId: lineId, visitId: visitId }});"
                >
                  Continue to Guns Equalization &nbsp;
                  <font-awesome-icon
                    :icon="['fas', 'circle-chevron-right']"
                    size="lg"
                  />
                </soft-button>
              </div>
            </div>
          </div>
        </div>
        <stepper-line-visit
          :line-id="lineId"
          :visit="visit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import axios from "axios";
import StepperLineVisit from "./components/StepperLineVisit.vue";
import SoftButton from "../../../components/SoftButton.vue";
import { useGetVisit, useGetLine } from "@/views/composables.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowRotateLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons";

library.add([faArrowRotateLeft, faCircleChevronRight]);

export default {
  name: "HealthCheck",
  components: {
    StepperLineVisit,
    SoftButton,
    FontAwesomeIcon,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    visitId: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { visit, getVisit } = useGetVisit();
    const { line, getLine } = useGetLine();
    return { visit, getVisit, line, getLine };
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;
    return {
      gun_to_gun_distance_check_received: false,
      gun_to_gun_distance_check_form: false,
      nozzles_check_received: false,
      nozzles_check_form: false,
      nozzle_last_changed_date_received: "",
      nozzle_last_changed_date_form: "",
      notes_received: "",
      notes_form: "",
    };
  },
  computed: {
    formUpdated() {
      return (
        this.gun_to_gun_distance_check_received !== this.gun_to_gun_distance_check_form ||
        this.nozzles_check_received !== this.nozzles_check_form ||
        this.nozzle_last_changed_date_received !== this.nozzle_last_changed_date_form ||
        this.notes_received !== this.notes_form
      );
    },
  },
  watch: {
    "$store.state.user_data.language"() {
      this.$i18n.locale = this.$store.state.user_data.language;
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    async getData() {
      await Promise.all([this.getVisit(this.visitId), this.getHealthCheck(), this.getLine(this.lineId)]);
    },
    async saveHealthCheck() {
      const formData = {
        gun_to_gun_distance_check: this.gun_to_gun_distance_check_form,
        nozzles_check: this.nozzles_check_form,
        nozzle_last_changed_date: new Date(this.nozzle_last_changed_date_form).toISOString(),
        notes: this.notes_form,
        progress_status: this.getFormProgressStatus(),
      };

      try {
        await axios.patch("/api/v1/blueprint/healthcheckstage/" + this.visitId + "/", formData);

        await this.getVisit(this.visitId);

        this.$swal({
          title: "Changes saved",
          text: "Health Check Data" + " " + "was saved successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          this.getHealthCheck();
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getHealthCheck() {
      try {
        let response = await axios.get("/api/v1/blueprint/healthcheckstage/" + this.visitId);

        this.gun_to_gun_distance_check_received = response.data.gun_to_gun_distance_check;
        this.gun_to_gun_distance_check_form = response.data.gun_to_gun_distance_check;

        this.nozzles_check_received = response.data.nozzles_check;
        this.nozzles_check_form = response.data.nozzles_check;

        if (response.data.nozzle_last_changed_date === null) {
          const today = new Date().toISOString().split("T")[0];
          this.nozzle_last_changed_date_received = today;
          this.nozzle_last_changed_date_form = today;
        } else {
          this.nozzle_last_changed_date_received = new Date(response.data.nozzle_last_changed_date)
            .toISOString()
            .split("T")[0];
          this.nozzle_last_changed_date_form = new Date(response.data.nozzle_last_changed_date)
            .toISOString()
            .split("T")[0];
        }

        this.notes_received = response.data.notes;

        if (response.data.notes === null) {
          this.notes_received = "";
          this.notes_form = "";
        } else {
          this.notes_received = response.data.notes;
          this.notes_form = response.data.notes;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getFormProgressStatus() {
      const PROGRESS_STATUS_PENDING = "Pending";
      const PROGRESS_STATUS_IN_PROGRESS = "In Progress";
      const PROGRESS_STATUS_COMPLETED = "Completed";

      if (
        this.gun_to_gun_distance_check_form === true &&
        this.nozzles_check_form === true &&
        this.nozzle_last_changed_date_form !== ""
      ) {
        return PROGRESS_STATUS_COMPLETED;
      } else if (
        this.gun_to_gun_distance_check_form === true ||
        this.nozzles_check_form === true ||
        this.nozzle_last_changed_date_form !== "" ||
        this.notes_form !== ""
      ) {
        return PROGRESS_STATUS_IN_PROGRESS;
      } else {
        return PROGRESS_STATUS_PENDING;
      }
    },
  },
};
</script>

<i18n>
  {
    "EN": {
      "Health Check": "Health Check",
    },
    "DE": {
      "Health Check": "Gesundheitscheck",
    },
    "ES": {
      "Health Check": "Chequeo de salud",
    },
    "FR": {
      "Health Check": "Vérification de santé",
    },
    "IT": {
      "Health Check": "Controllo di salute",
    },
    "PL": {
      "Health Check": "Badanie lekarskie",
    },
    "TR": {
      "Health Check": "Sağlık kontrolü",
    },
    "ZH": {
      "Health Check": "健康检查",
    }
  }
</i18n>
